/* ------------------------------------------------------------ */
/* -- Select Init -- */
/* ------------------------------------------------------------ */
const selectInit = () => {
  if (typeof NiceSelect !== 'undefined') {
    const sectorRegion = NiceSelect.bind(document.getElementById("regionSelect"), {
      searchable: false, placeholder: 'Filter Region', selectedtext: 'selected'
    });
    const sectorStage = NiceSelect.bind(document.getElementById("stageSelect"), {
      searchable: false, placeholder: 'Filter Stage', selectedtext: 'selected'
    });
    const sectorSelect = NiceSelect.bind(document.getElementById("sectorSelect"), {
      searchable: false, placeholder: 'Filter Sector', selectedtext: 'selected'
    });
    const apply = document.querySelector('#applyGroupFilters');
    const reset = document.querySelector('.reset-company-filter');

    if(reset != null) {
      reset.addEventListener('click', () => {
        sectorRegion.clear();
        sectorSelect.clear();
        sectorStage.clear();
        // Simulate click on the apply button
        apply.click();
      });
    }
  }
};

export default selectInit;
